export type TagSeverity = 'success' | 'secondary' | 'info' | 'warn' | 'danger' | 'contrast' | null | undefined;

export enum WorkflowStatus {
    Draft = 'Draft',
    PendingReview = 'PendingReview',
    UnderReview = 'UnderReview',
    ReviewApproved = 'ReviewApproved',
    PendingApproval = 'PendingApproval',
    UnderApproval = 'UnderApproval',
    Approved = 'Approved',
    FinalApproved = 'FinalApproved',
    ReturnedForRevision = 'ReturnedForRevision'
}

export const WorkflowStatusLabel: Record<WorkflowStatus, string> = {
    [WorkflowStatus.Draft]: 'مسودة',
    [WorkflowStatus.PendingReview]: 'بانتظار المراجعة',
    [WorkflowStatus.UnderReview]: 'قيد المراجعة',
    [WorkflowStatus.ReviewApproved]: 'تم اعتماد المراجع',
    [WorkflowStatus.PendingApproval]: 'بانتظار الاعتماد',
    [WorkflowStatus.UnderApproval]: 'قيد الاعتماد',
    [WorkflowStatus.Approved]: 'معتمدة',
    [WorkflowStatus.FinalApproved]: 'اعتماد نهائي',
    [WorkflowStatus.ReturnedForRevision]: 'معادة للتدقيق'
};

export const WorkflowStatusSeverity: Record<WorkflowStatus, TagSeverity> = {
    [WorkflowStatus.Draft]: 'secondary',
    [WorkflowStatus.PendingReview]: 'warn',
    [WorkflowStatus.UnderReview]: 'warn',
    [WorkflowStatus.ReviewApproved]: 'info',
    [WorkflowStatus.PendingApproval]: 'warn',
    [WorkflowStatus.UnderApproval]: 'info',
    [WorkflowStatus.Approved]: 'success',
    [WorkflowStatus.FinalApproved]: 'success',
    [WorkflowStatus.ReturnedForRevision]: 'danger'
};